import React, { Component } from "react";
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import DefaultLockerOptions from "../LockerOptions/DefaultLockerOptions";
import SocicamLockerOptions from "../LockerOptions/SocicamLockerOptions";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import Arrow from "@material-ui/icons/ArrowBackIos";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Circular from "components/Circular/Circular";
import Dropdown from "components/Dropdown/Dropdown";
import { getAllLockers } from "../../services/lockers/lockers";
import {
  getSlots as buscarEscaninho,
  openSlot,
} from "../../services/slots/slots";

const styles = (theme) => ({
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  iconView: {
    color: "gray !important",
  },
  iconViewArrow: {
    color: "white !important",
  },
  buttonIcon: {
    padding: "5px",
  },
  dropdown: {
    right: "1.5%",
    top: "24%",
    position: "absolute",
  },
});

class ListLockers extends Component {
  constructor(props) {
    super(props);
    this.handleLoginClick = this.handleLoginClick.bind(this);
    this.handleLogoutClick = this.handleLogoutClick.bind(this);
    this.getLockers = this.getLockers.bind(this);
   
    this.state = {
      isLoggedIn: false,
      showSlots: false,
      lockersData: [["Nenhum locker encontrado!"]],
      currentLocker: null,
      lockerName: null,
      circular: true,
      options: ["Ativo", "Inativo"],
      selected: "Ativo",
    };
  }

  componentDidMount() {
    this.getLockers();
  }

  handleLoginClick() {
    this.setState({ isLoggedIn: true });
  }

  handleLogoutClick() {
    this.setState({ isLoggedIn: false });
  }

  getLockers() {
    let { lockersData } = this.state;

    getAllLockers((data) => {
      let currStatus = this.state.selected ==="Ativo" ? "active" : "inactive";
      console.log("Selected " + this.state.selected);

      let lockers = data.filter((d) => d.status ===currStatus);
      lockersData = lockers.length > 0 ? [] : lockersData;

      lockers.forEach((locker) => {
        let { id, name, status, qiStatus, bateria, appVersion } = locker;
        buscarEscaninho(id, (slots) => {
          let smallSlots = slots.filter((sl) => sl.size ==="small");
          let mediumSlots = slots.filter((sl) => sl.size ==="medium");
          let largeSlots = slots.filter((sl) => sl.size ==="large");
          
          let SlotsCount = slots.length;
          let AllocatedCount = slots.filter((sl) => sl.status ==="allocated")
            .length;
          let UnavailableCount = slots.filter(
            (sl) =>
              sl.status ==="unavailable" ||
              sl.status ==="reserved" ||
              sl.status ==="to_be_free" ||
              sl.status ==="dirty"
          ).length;
          let AvailableCount =
            slots.length - (AllocatedCount + UnavailableCount);

          let occupation = (AllocatedCount * 100) / (SlotsCount - UnavailableCount)
        });

        lockersData.push([
          name,
          status,
          qiStatus,
          bateria,
          appVersion,
          <IconButton
            onClick={() => this.handleEdit(id, name)}
            aria-label="view"
          >
            <Visibility className={this.props.classes.iconView} />
          </IconButton>,
        ]);
      });
      
      this.setState({ lockersData, circular: false });
    });
  }

  render() {
    const { classes } = this.props;
    const { showSlots, circular, selected, lockersData } = this.state;

     return (
      <Card>
        <CardHeader color="primary">
          <h4 className={classes.cardTitleWhite}>Lockers</h4>
          <p className={classes.cardCategoryWhite}>
            {selected !== "Ativo" ? "Lockers inativos" : "Lockers ativos"}
          </p>
          <Dropdown
            className={classes.dropdown}
            options={this.state.options}
            selected={this.state.selected}
            setSelected={this.setSelected}
          />
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}></GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    );
  }
}
export default withStyles(styles)(ListLockers);
